
// Constants
import { APP_CONFIG } from '../constants/config.constant';

// Helpers
import { resolveValueByKey } from '../helpers';

export const ConfigMapper = {

    replaceInfoConfig: (config) => {
        
        try {
            
            ConfigMapper.replaceInfoConfigPages(config.configuration);
            ConfigMapper.replaceInfoConfigApi(config.configuration);
            ConfigMapper.replaceInfoConfigGuard(config.configuration);
            ConfigMapper.replaceInfoConfigControl(config.configuration);
            ConfigMapper.replaceInfoConfigPagination(config.configuration);
            ConfigMapper.replaceInfoConfigSplash(config.configuration);
            ConfigMapper.replaceInfoConfigAnalytics(config.configuration);
            ConfigMapper.appendVersionInfo(config.configuration);
            ConfigMapper.appendMessageInfo(config.configuration);
            ConfigMapper.appendMenuInfo(config.configuration);

        } catch (error) {

            return;
        }        
    },

    replaceInfoConfigPages: (config) => {

        if ( config && config.PAGES ) {

            APP_CONFIG.PAGES.LOGIN.rules.inputs.username.required = resolveValueByKey(config.PAGES.LOGIN.rules.inputs.username, APP_CONFIG.PAGES.LOGIN.rules.inputs.username, 'required' );
            APP_CONFIG.PAGES.LOGIN.rules.inputs.username.maxLength = resolveValueByKey(config.PAGES.LOGIN.rules.inputs.username, APP_CONFIG.PAGES.LOGIN.rules.inputs.username, 'maxLength' );
            APP_CONFIG.PAGES.LOGIN.rules.inputs.username.pattern.message = resolveValueByKey(config.PAGES.LOGIN.rules.inputs.username.pattern, APP_CONFIG.PAGES.LOGIN.rules.inputs.username.pattern, 'message' );
            APP_CONFIG.PAGES.LOGIN.rules.inputs.password = resolveValueByKey(config.PAGES.LOGIN.rules.inputs, APP_CONFIG.PAGES.LOGIN.rules.inputs, 'password' );

            APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email.required = resolveValueByKey(config.PAGES.RESET_PASSWORD.rules.inputs.email, APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email, 'required' );
            APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email.maxLength = resolveValueByKey(config.PAGES.RESET_PASSWORD.rules.inputs.email, APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email, 'maxLength' );
            APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email.minLength = resolveValueByKey(config.PAGES.RESET_PASSWORD.rules.inputs.email, APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email, 'minLength' );
            APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email.pattern.message = resolveValueByKey(config.PAGES.RESET_PASSWORD.rules.inputs.email.pattern, APP_CONFIG.PAGES.RESET_PASSWORD.rules.inputs.email.pattern, 'message' );

            APP_CONFIG.PAGES.QR_SCAN.title = resolveValueByKey(config.PAGES.QR_SCAN, APP_CONFIG.PAGES.QR_SCAN, 'title' );
            APP_CONFIG.PAGES.QR_SCAN.showMenuButton = resolveValueByKey(config.PAGES.QR_SCAN, APP_CONFIG.PAGES.QR_SCAN, 'showMenuButton' );
            APP_CONFIG.PAGES.QR_SCAN.messages = resolveValueByKey(config.PAGES.QR_SCAN, APP_CONFIG.PAGES.QR_SCAN, 'messages' );
            APP_CONFIG.PAGES.QR_SCAN.permissions = resolveValueByKey(config.PAGES.QR_SCAN, APP_CONFIG.PAGES.QR_SCAN, 'permissions' );
    
            APP_CONFIG.PAGES.DOCUMENT.title = resolveValueByKey(config.PAGES.DOCUMENT, APP_CONFIG.PAGES.DOCUMENT, 'title' );
            APP_CONFIG.PAGES.DOCUMENT.showMenuButton = resolveValueByKey(config.PAGES.DOCUMENT, APP_CONFIG.PAGES.DOCUMENT, 'showMenuButton' );
            APP_CONFIG.PAGES.DOCUMENT.rules = resolveValueByKey(config.PAGES.DOCUMENT, APP_CONFIG.PAGES.DOCUMENT, 'rules' );
            APP_CONFIG.PAGES.DOCUMENT.permissions = resolveValueByKey(config.PAGES.DOCUMENT, APP_CONFIG.PAGES.DOCUMENT, 'permissions' );
    
            APP_CONFIG.PAGES.BENEFIT.title = resolveValueByKey(config.PAGES.BENEFIT, APP_CONFIG.PAGES.BENEFIT, 'title' );
            APP_CONFIG.PAGES.BENEFIT.showMenuButton = resolveValueByKey(config.PAGES.BENEFIT, APP_CONFIG.PAGES.BENEFIT, 'showMenuButton' );
            APP_CONFIG.PAGES.BENEFIT.messages = resolveValueByKey(config.PAGES.BENEFIT, APP_CONFIG.PAGES.BENEFIT, 'messages' );
            APP_CONFIG.PAGES.BENEFIT.permissions = resolveValueByKey(config.PAGES.BENEFIT, APP_CONFIG.PAGES.BENEFIT, 'permissions' );
    
            APP_CONFIG.PAGES.DETAIL.title = resolveValueByKey(config.PAGES.DETAIL, APP_CONFIG.PAGES.DETAIL, 'title' );
            APP_CONFIG.PAGES.DETAIL.showMenuButton = resolveValueByKey(config.PAGES.DETAIL, APP_CONFIG.PAGES.DETAIL, 'showMenuButton' );
            APP_CONFIG.PAGES.DETAIL.messages = resolveValueByKey(config.PAGES.DETAIL, APP_CONFIG.PAGES.DETAIL, 'messages' );
            APP_CONFIG.PAGES.DETAIL.validate.transactionStatus = resolveValueByKey(config.PAGES.DETAIL.validate, APP_CONFIG.PAGES.DETAIL.validate, 'transactionStatus' );
            APP_CONFIG.PAGES.DETAIL.rules = resolveValueByKey(config.PAGES.DETAIL, APP_CONFIG.PAGES.DETAIL, 'rules' );
            APP_CONFIG.PAGES.DETAIL.permissions = resolveValueByKey(config.PAGES.DETAIL, APP_CONFIG.PAGES.DETAIL, 'permissions' );

            APP_CONFIG.PAGES.HISTORY.title = resolveValueByKey(config.PAGES.HISTORY, APP_CONFIG.PAGES.HISTORY, 'title' );
            APP_CONFIG.PAGES.HISTORY.showMenuButton = resolveValueByKey(config.PAGES.HISTORY, APP_CONFIG.PAGES.HISTORY, 'showMenuButton' );
            APP_CONFIG.PAGES.HISTORY.fabButton = resolveValueByKey(config.PAGES.HISTORY, APP_CONFIG.PAGES.HISTORY, 'fabButton' );
            APP_CONFIG.PAGES.HISTORY.messages = resolveValueByKey(config.PAGES.HISTORY, APP_CONFIG.PAGES.HISTORY, 'messages' );
            APP_CONFIG.PAGES.HISTORY.permissions = resolveValueByKey(config.PAGES.HISTORY, APP_CONFIG.PAGES.HISTORY, 'permissions' );

            APP_CONFIG.PAGES.CONTACT.title = resolveValueByKey(config.PAGES.CONTACT, APP_CONFIG.PAGES.CONTACT, 'title' );
            APP_CONFIG.PAGES.CONTACT.showMenuButton = resolveValueByKey(config.PAGES.CONTACT, APP_CONFIG.PAGES.CONTACT, 'showMenuButton' );
            APP_CONFIG.PAGES.CONTACT.rules = resolveValueByKey(config.PAGES.CONTACT, APP_CONFIG.PAGES.CONTACT, 'rules' );
            APP_CONFIG.PAGES.CONTACT.attributes = resolveValueByKey(config.PAGES.CONTACT, APP_CONFIG.PAGES.CONTACT, 'attributes' );
            APP_CONFIG.PAGES.CONTACT.permissions = resolveValueByKey(config.PAGES.CONTACT, APP_CONFIG.PAGES.CONTACT, 'permissions' );

        }
    },

    replaceInfoConfigApi: (config) => {

        if( config && config.API ) {

            APP_CONFIG.API.AUTH = resolveValueByKey(config.API, APP_CONFIG.API, 'AUTH' );
            APP_CONFIG.API.VIRTUAL_CREDENTIAL = resolveValueByKey(config.API, APP_CONFIG.API, 'VIRTUAL_CREDENTIAL' );
        }
    },

    replaceInfoConfigGuard: (config) => {

        if( config && config.GUARDS ) {

            APP_CONFIG.GUARDS.AUTH = resolveValueByKey(config.GUARDS, APP_CONFIG.GUARDS, 'AUTH' );
        }
    },

    replaceInfoConfigControl: (config) => {

        if( config && config.CONTROLS ) {

            APP_CONFIG.CONTROLS.INFINITE_SCROLL = resolveValueByKey(config.CONTROLS, APP_CONFIG.CONTROLS, 'INFINITE_SCROLL' );
            APP_CONFIG.CONTROLS.TOAST = resolveValueByKey(config.CONTROLS, APP_CONFIG.CONTROLS, 'TOAST' );
            APP_CONFIG.CONTROLS.LOADING = resolveValueByKey(config.CONTROLS, APP_CONFIG.CONTROLS, 'LOADING' );
            APP_CONFIG.CONTROLS.SCAN = resolveValueByKey(config.CONTROLS, APP_CONFIG.CONTROLS, 'SCAN' );
        }
    },

    replaceInfoConfigPagination: (config) => {

        if( config && config.PAGINATION ) {

            APP_CONFIG.PAGINATION.MOBILE = resolveValueByKey(config.PAGINATION, APP_CONFIG.PAGINATION, 'MOBILE' );
            APP_CONFIG.PAGINATION.WEB = resolveValueByKey(config.PAGINATION, APP_CONFIG.PAGINATION, 'WEB' );
        }
    },

    replaceInfoConfigSplash: (config) => {

        if( config && config.SPLASH ) {

            APP_CONFIG.SPLASH.WEB = resolveValueByKey(config.SPLASH, APP_CONFIG.SPLASH, 'WEB' );
            APP_CONFIG.SPLASH.MOBILE = resolveValueByKey(config.SPLASH, APP_CONFIG.SPLASH, 'MOBILE' );
        }
    },

    replaceInfoConfigAnalytics: (config) => {

        if( config && config.ANALYTICS ) {

            APP_CONFIG.ANALYTICS.EVENTS.LOGIN = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'LOGIN' );
            APP_CONFIG.ANALYTICS.EVENTS.RECOVER_PASSWORD = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'RECOVER_PASSWORD' );
            APP_CONFIG.ANALYTICS.EVENTS.MENU = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'MENU' );
            APP_CONFIG.ANALYTICS.EVENTS.QR_PAGE = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'QR_PAGE' );
            APP_CONFIG.ANALYTICS.EVENTS.DNI_PAGE = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'DNI_PAGE' );
            APP_CONFIG.ANALYTICS.EVENTS.CONTACT_PAGE = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'CONTACT_PAGE' );
            APP_CONFIG.ANALYTICS.EVENTS.DETAIL_PAGE = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'DETAIL_PAGE' );
            APP_CONFIG.ANALYTICS.EVENTS.TRANSACTION = resolveValueByKey(config.ANALYTICS.EVENTS, APP_CONFIG.ANALYTICS.EVENTS, 'TRANSACTION' );
        }
    },

    appendVersionInfo: (config) => {

        if (config && config.VERSION) {
            APP_CONFIG['VERSION'] = config.VERSION;
        }
    },

    appendMessageInfo: (config) => {

        if (config && config.MESSAGE) {

            APP_CONFIG.MESSAGE.ALERT['mainteinment'] = config.MESSAGE.ALERT.mainteinment;
            APP_CONFIG.MESSAGE.ALERT.resetPassword = resolveValueByKey(config.MESSAGE.ALERT, APP_CONFIG.MESSAGE.ALERT, 'resetPassword' );
            APP_CONFIG.MESSAGE.INFO.permissions = resolveValueByKey(config.MESSAGE.INFO, APP_CONFIG.MESSAGE.INFO, 'permissions' );
        }
    },

    appendMenuInfo: (config) => {

        if (config && config.MENU) {
            APP_CONFIG['MENU'] = config.MENU;
        }
    }

};